import { ref, computed } from 'vue';
import { toTypedSchema } from '@vee-validate/zod';

import type { ClientProps } from '../utils/types';
import { clientPropsSchema } from '../utils/schemas';

import { useAppForm } from '../composables/useAppForm';

export function useClientFormFields() {
  const addClientSchema = computed(() => toTypedSchema(clientPropsSchema));

  const { form, handleSubmit, errors, resetForm } = useAppForm({
    fields: [
      'first_name',
      'last_name',
      'email',
      'phone',
      'street',
      'house_number',
      'apartment_number',
      'province',
      'city',
      'postal_code',
    ],
    validationSchema: addClientSchema,
  });

  function populateFormWithClientData(client: ClientProps) {
    form.first_name = client.first_name;
    form.last_name = client.last_name;
    form.email = client.email;
    form.phone = client.phone;
    form.street = client.street;
    form.house_number = client.house_number;
    form.apartment_number = client.apartment_number;
    form.province = client.province;
    form.city = client.city;
    form.postal_code = client.postal_code;
  }

  return {
    form,
    handleSubmit,
    errors,
    resetForm,
    populateFormWithClientData,
  };
}
